'use strict';

import {EwSiteApp} from "../../app/ewsiteapp.js";

import {ProjectsListCtrl} from "./projectslistctrl.js";
EwSiteApp.controller('ProjectsListCtrl', ["$scope", "$http", "$filter", "$timeout", "$locale", "jsDataService", ProjectsListCtrl]);

import {ProjectInfoCtrl} from "./projectinfoctrl.js";
EwSiteApp.controller('ProjectInfoCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", ProjectInfoCtrl]);

import {ProjectReportsCtrl} from "./projectreportsctrl.js";
EwSiteApp.controller('ProjectReportsCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", ProjectReportsCtrl]);

import {AnnexPdfCtrl} from "./annexpdfctrl.js";
EwSiteApp.controller('AnnexPdfCtrl', ["$scope", "$filter", "$mdDialog", "jsDataService", "notify", AnnexPdfCtrl]);

import {PdfGenerateCtrl} from "./pdfgeneratectrl.js";
EwSiteApp.controller('PdfGenerateCtrl', ["$scope", "$http", "notify", PdfGenerateCtrl]);

import {commentCtrl} from "./commentctrl.js";
EwSiteApp.controller('commentCtrl', ["$scope", "$filter", "jsDataService", "notify", commentCtrl]);

import {ProjectReportsWpActivDelivCtrl} from "./projectreportswpactivdelivctrl.js";
EwSiteApp.controller('ProjectReportsWpActivDelivCtrl', ["$scope", "$http", "$filter", "$mdDialog", "jsDataService", "notify", ProjectReportsWpActivDelivCtrl]);

import {ProjectReportsRiskCtrl} from "./projectreportriskctrl.js";
EwSiteApp.controller('ProjectReportsRiskCtrl', ["$scope", "$http", "$filter", "$mdDialog", "jsDataService", "notify", ProjectReportsRiskCtrl]);

import {ReportingTableCtrl} from "./reportingtablectrl.js";
EwSiteApp.controller('ReportingTableCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", ReportingTableCtrl]);

import {ProjectFinancingReportCtrl} from "./projectfinancingreportctrl.js";
EwSiteApp.controller('ProjectFinancingReportCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", ProjectFinancingReportCtrl]);

import {Projectreportstimelinectrl} from "./projectreportstimelinectrl";
EwSiteApp.controller('Projectreportstimelinectrl', ["$scope", "$filter", "jsDataService", Projectreportstimelinectrl]);

import {Projectreportsdeclarationsctrl} from "./projectreportsdeclarationsctrl";
EwSiteApp.controller('Projectreportsdeclarationsctrl', ["$scope", "$filter", "jsDataService", Projectreportsdeclarationsctrl]);

import {Projectreportsoverviewctrl} from "./projectreportsoverviewctrl";
EwSiteApp.controller('Projectreportsoverviewctrl', ["$scope", "$filter", "jsDataService", Projectreportsoverviewctrl]);

import {ProjectChangeCtrl} from "./projectchangectrl.js";
EwSiteApp.controller('ProjectChangeCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", ProjectChangeCtrl]);

import {ProjectChangeDetailsCtrl} from "./projectchangedetailsctrl.js";
EwSiteApp.controller('ProjectChangeDetailsCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", ProjectChangeDetailsCtrl]);

import {ProjectsResponsibleCtrl} from "./projectsresponsiblectrl.js";
EwSiteApp.controller('ProjectsResponsibleCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", ProjectsResponsibleCtrl]);

import {GAchecklistsCtrl} from "./gachecklistsctrl.js";
EwSiteApp.controller('GAchecklistsCtrl', ["$scope", "$filter", "$timeout", "$mdDialog", "jsDataService", "notify", GAchecklistsCtrl]);
import {Projectreportperiodicpdfctrl} from "./projectreportpdfctrl.js";
EwSiteApp.controller('Projectreportperiodicpdfctrl', ["$scope", "$http", "notify", Projectreportperiodicpdfctrl]);

import {ProjectReportContinousPdfCtrl} from "./projectreportcontinouspdfctrl.js";
EwSiteApp.controller('ProjectReportContinousPdfCtrl', ["$scope", "$http", "notify", ProjectReportContinousPdfCtrl]);

import {PeriodicReportingCtrl} from "./periodicreportingctrl";
EwSiteApp.controller('PeriodicReportingCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", PeriodicReportingCtrl]);

import {ProjectRequestIdentityCtrl} from "./projectrequestidentityctrl.js";
EwSiteApp.controller('ProjectRequestIdentityCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", ProjectRequestIdentityCtrl]);

import {ProjectSignCtrl} from "./projectsignctrl.js";
EwSiteApp.controller('ProjectSignCtrl', ["$scope", "$filter", "jsDataService", "$mdDialog", ProjectSignCtrl]);

import {ReportStatusCtrl} from "./reportstatusctrl.js";
EwSiteApp.controller('ReportStatusCtrl', ["$scope", "jsDataService", "$mdDialog", ReportStatusCtrl]);

import {PeriodicReportChecklistCtrl} from "./periodicreportchecklistctrl.js";
EwSiteApp.controller('PeriodicReportChecklistCtrl', ["$scope", "$filter", "$timeout", "$mdDialog", "jsDataService", "notify", PeriodicReportChecklistCtrl]);

import {ProjectRecoveryListCtrl} from "./projectrecoverylistctrl.js";
EwSiteApp.controller('ProjectRecoveryListCtrl', ["$scope", "$filter", "jsDataService", ProjectRecoveryListCtrl]);

import {ProjectRecoveryCtrl} from "./projectrecoveryctrl.js";
EwSiteApp.controller('ProjectRecoveryCtrl', ["$scope", "$filter", "$timeout", "$mdDialog", "jsDataService", "notify", ProjectRecoveryCtrl]);

import {ProjectsIndicatorsCtrl} from "./projectindicatorsctrl.js";
EwSiteApp.controller('ProjectsIndicatorsCtrl', ["$scope", "$filter", "$mdDialog", "jsDataService", ProjectsIndicatorsCtrl]);